import { http } from '@pendo/http';
const metaGroupsApi = '/api/s/_SID_/category/metagroup';

const buildMemberPayload = (categoryId) => ({
    items: [{
        itemId: categoryId,
        itemType: 'ItemGroup',
        metaGroupMemberAncestorType: 'guideCategory',
    }],
});

export function fetchMetaGroups ({ items } = {}) {
    const params = items ? '?items=true' : '';

    return http.get(`${metaGroupsApi}${params}`);
}

export function fetchMetaGroup ({ id, items } = {}) {
    const params = items ? '?items=true' : '';

    return http.get(`${metaGroupsApi}/${id}${params}`);
}

export function createMetaGroup (metaGroup) {
    return http.post('/api/s/_SID_/category', {
        type: 'metaGroup',
        ...metaGroup,
    });
}

export function addCategoryToMetaGroup ({ metaGroupId, categoryId }) {
    return http.patch(
        `/api/s/_SID_/category/metaGroup/${metaGroupId}/members/add`,
        buildMemberPayload(categoryId),
    );
}

export function removeCategoryFromMetaGroup ({ metaGroupId, categoryId }) {
    return http.patch(
        `/api/s/_SID_/category/metaGroup/${metaGroupId}/members/remove`,
        buildMemberPayload(categoryId),
    );
}
